import { IModules } from "lib/millennium.core"
import { modules } from "./millennium.modules"

// Registry das PÁGINAS do core. Separado de `millennium.modules.ts` DE PROPÓSITO: o shell
// (`millennium.browser`) importa `millennium.modules` (loadModule + o registry `modules`), mas NÃO deve
// arrastar as páginas do core. Quem importa este arquivo é o ENTRY normal (`millennium.ts`), que
// registra as páginas no `modules`. Um entry DEDICADO (ex.: o bundle de contingência do Omni) NÃO
// importa este arquivo → as páginas do core não são type-checadas nem empacotadas; ele registra
// apenas a(s) sua(s) própria(s) página(s) no `modules`.
const corePages: IModules = {
  "home": {
    instance: () => import("./pages/millennium.home/millennium.home"),
    css: () => import("./pages/millennium.home/millennium.home.scss"),
    html: () => import("./pages/millennium.home/millennium.home.html")
  },
  "dataform": {
    instance: () => import("./pages/millennium.dataform/millennium.dataform"),
    css: () => import("./pages/millennium.dataform/millennium.dataform.scss"),
    html: () => import("./pages/millennium.dataform/millennium.dataform.html")
  },
  "dataview": {
    instance: () => import("./pages/millennium.dataview/millennium.dataview"),
    css: () => import("./pages/millennium.dataview/millennium.dataview.scss"),
    html: () => import("./pages/millennium.dataview/millennium.dataview.html")
  },
  "portal": {
    instance: () => import("./pages/millennium.portal/millennium.portal"),
    css: () => import("./pages/millennium.portal/millennium.portal.scss"),
    html: () => import("./pages/millennium.portal/millennium.portal.html")
  },
  "playground": {
    instance: () => import("./pages/playground/playground"),
    css: () => import("./pages/playground/playground.scss"),
    html: () => Promise.resolve()
  },
  "smoke-form": {
    instance: () => import("./pages/smoke-form/smoke-form"),
    css: () => import("./pages/smoke-form/smoke-form.scss"),
    html: () => import("./pages/smoke-form/smoke-form.html")
  },
  "smoke-dataview": {
    instance: () => import("./pages/smoke-dataview/smoke-dataview"),
    css: () => import("./pages/smoke-dataview/smoke-dataview.scss"),
    html: () => import("./pages/smoke-dataview/smoke-dataview.html")
  },
  "playground-lit": {
    instance: () => import("./pages/playground/playground-lit"),
    css: () => Promise.resolve(),
    html: () => Promise.resolve()
  },
  "reports": {
    instance: () => import("./pages/millennium.reports/millennium.reports"),
    css: () => import("./pages/millennium.reports/millennium.reports.scss"),
    html: () => import("./pages/millennium.reports/millennium.reports.html")
  },
  "reports_catalog": {
    instance: () => import("./pages/millennium.reports/millennium.reports.catalog"),
    css: () => import("./pages/millennium.reports/millennium.reports.catalog.scss"),
    html: () => import("./pages/millennium.reports/millennium.reports.catalog.html")
  },
  "reports_designer": {
    instance: () => import("./pages/millennium.reports.designer/millennium.reports.designer"),
    css: () => Promise.resolve(),
    html: () => import("./pages/millennium.reports.designer/millennium.reports.designer.html")
  },
  "configuration": {
    instance: () => import("./pages/millennium.configuration/millennium.configuration"),
    css: () => import("./pages/millennium.configuration/millennium.configuration.scss"),
    html: () => import("./pages/millennium.configuration/millennium.configuration.html")
  },
  "modules": {
    instance: () => import("./pages/millennium.plugins/millennium.plugins"),
    css: () => import("./pages/millennium.plugins/millennium.plugins.scss"),
    html: () => import("./pages/millennium.plugins/millennium.plugins.html")
  },
  "monitor": {
    instance: () => import("./pages/millennium.monitor/millennium.monitor"),
    css: () => import("./pages/millennium.monitor/millennium.monitor.scss"),
    html: () => import("./pages/millennium.monitor/millennium.monitor.html")
  },
  "openbanking": {
    instance: () => import("./pages/millennium.openbanking/millennium.openbanking"),
    css: () => import("./pages/millennium.openbanking/millennium.openbanking.scss"),
    html: () => import("./pages/millennium.openbanking/millennium.openbanking.html")
  },
  "openbankingListaContas": {
    instance: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas"),
    css: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas.scss"),
    html: () => import("./pages/millennium.openbanking/millennium.openbanking.Contas.html")
  },
  "linx_explorer": {
    instance: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer"),
    css: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer.scss"),
    html: () => import("./pages/millennium.linx_explorer/millennium.linx_explorer.html")
  },
  "openlink": {
    instance: () => import("./pages/millennium.openlink/millennium.openlink"),
    css: () => import("./pages/millennium.openlink/millennium.openlink.scss"),
    html: () => import("./pages/millennium.openlink/millennium.openlink.html")
  },
  "workflow": {
    instance: () => import("./pages/millennium.workflow/millennium.workflow"),
    css: () => import("./pages/millennium.workflow/millennium.workflow.scss"),
    html: () => import("./pages/millennium.workflow/millennium.workflow.html")
  },
  "projected_inventory": {
    instance: () => import("./pages/millennium.projected_inventory/millennium.projected_inventory"),
    css: () => import("./pages/millennium.projected_inventory/millennium.projected_inventory.scss"),
    html: () => import("./pages/millennium.projected_inventory/millennium.projected_inventory.html")
  },
  "eventos": {
    instance: () => import("./pages/millennium.eventos/millennium.eventos"),
    css: () => import("./pages/millennium.eventos/millennium.eventos.scss"),
    html: () => import("./pages/millennium.eventos/millennium.eventos.html")
  },
  "saldo_extrato": {
    instance: () => import("./pages/millennium.saldo_extrato/millennium.saldo_extrato"),
    css: () => import("./pages/millennium.saldo_extrato/millennium.saldo_extrato.scss"),
    html: () => import("./pages/millennium.saldo_extrato/millennium.saldo_extrato.html")
  },
  "design-system": {
    instance: () => import("./pages/design-system/design-system"),
    css: () => import("./pages/design-system/design-system.scss"),
    html: () => Promise.resolve()
  },
}

Object.assign(modules, corePages)
